import React from 'react';
import Box from '../box/box.jsx';

import addExtensionIcon from '../gui/icon--extensions.svg';

import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import styles from './extension-button.css';
const messages = defineMessages({
    addExtension: {
        id: 'gui.gui.addExtension',
        description: 'Button to add an extension in the target pane',
        defaultMessage: 'Add Extension'
    }
})

class ExtensionButton extends React.Component{
    constructor(){
        super()
    }
    render(){
        const { 
            intl,
            onExtensionButtonClick
        } = this.props
        return (
            <Box className={styles.extensionButtonContainer}>
                <button
                    className={styles.extensionButton}
                    title={intl.formatMessage(messages.addExtension)}
                    onClick={onExtensionButtonClick}
                >
                    <img
                        className={styles.extensionButtonIcon}
                        draggable={false}
                        src={addExtensionIcon}
                    />
                </button>
            </Box>
        )
    }
}

export default ExtensionButton